import * as Yup from 'yup';
import { EMAIL } from 'src/constants/regex.constants';

const inviteUserValidationSchema = Yup.object().shape({
  email: Yup.string()
    .required('Please enter email address')
    .matches(EMAIL, 'Please enter a valid email address')
});

export default inviteUserValidationSchema;
